import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { PopupPreviewImageComponent } from 'src/app/modules/shared/popup-preview-image/popup-preview-image.component';

@Component({
  selector: 'app-sku-view',
  templateUrl: './sku-view.component.html',
  styleUrls: ['./sku-view.component.scss']
})
export class SkuViewComponent implements OnInit, OnChanges,OnDestroy {
  @Input() sku;
  accountType:string;
  @Input() isRemove = false;
  @Output() removeSkuEvent: EventEmitter<any> = new EventEmitter();
  @Input() isCaseQty;
  @Input() qty;
  @Input() caseQty;
  @Output() updateCaseQty : EventEmitter<any> = new EventEmitter();
  @Output() updateqty: EventEmitter<any> = new EventEmitter();
  isValidQuantity: boolean = false;
  isValidCaseQuantity: boolean = false;
  caseQtyInput: FormControl;
  qtyInput: FormControl;
  private destroy$ = new Subject<void>();

  constructor(private dialog:MatDialog) { }

  ngOnInit(): void {
    const image = this.sku.ImageUrl || this.sku.Image || this.sku.image;
    this.sku.Image = image
      ? image.replace(
          "http://ecx.images-amazon.com/",
          "https://m.media-amazon.com/"
        )
      : "assets/images/No_image.png";

    this.accountType = this.sku.AccountType || this.sku.accountType || this.sku.type || this.sku.channel || "";
    this.accountType = this.accountType.toLowerCase();
    if(this.isRemove){
      this.qtyInput = new FormControl(this.qty, [
        Validators.required,  Validators.min( 1),        
      ]);
  
      this.caseQtyInput = new FormControl((this.sku.caseQty || this.sku.CaseQty) || 1, [
        Validators.required, Validators.min(1),
      ]); 
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.isRemove){
    const cases= ( this.sku.caseQty || this.sku.CaseQty);
    this.updateQuantities(cases ? cases : 1,true);
    }
    if(this.isCaseQty){
      this.qtyInput = new FormControl(this.qty, [
        Validators.required,  Validators.min( 1),  Validators.max(150),       
      ]);
    }else{
      this.qtyInput = new FormControl(this.qty, [
        Validators.required,  Validators.min( 1)    
      ]);
    }
  }

  previewImage(image) {
    this.dialog
      .open(PopupPreviewImageComponent, {
        width: "400px",
        data: {
          url: image,
          title: this.sku.title || this.sku.Title,
        },
      })
      .afterClosed()
      .subscribe((e: any) => {
      });
  }

  removeSku(sku){
    this.removeSkuEvent.emit(sku);
 }

 updateQty(event){
  this.updateQuantities(Number(event.target.value),false);
 }

 caseQtyChanged(event: any) {
  const caseQty = event.target.value;
  const totalQty = this.qty;
  const totalIsDevisable = totalQty % caseQty === 0;
  if (totalIsDevisable && caseQty >= 1 && caseQty <= 150)   {
    this.isValidCaseQuantity = true;    
  } else {
    this.isValidCaseQuantity = false;
  }
  this.updateQuantities(caseQty,true);
}

updateQuantities(qty,isCaseQty){
  const sku :any = {
    AccountSkuId : this.sku.accountSkuId || this.sku.AccountSkuId,
    Sku:this.sku.sku || this.sku.Sku,
    qty: qty,
    isCaseQty: isCaseQty
  }
  this.updateCaseQty.emit(sku);
 }

 ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.unsubscribe();
 }
}
